var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.186,
    height: 15.89,
    viewBox: "0 0 11.186 15.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89005",
    "data-name": "Group 89005",
    transform: "translate(-3.751 -1.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.774,0a3.77,3.77,0,0,0-.1,7.54.641.641,0,0,1,.175,0h.056A3.771,3.771,0,0,0,3.774,0Z",
    transform: "translate(5.57 1.512)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.629,1.108a7.888,7.888,0,0,0-8.064,0A3.136,3.136,0,0,0,0,3.674a3.11,3.11,0,0,0,1.557,2.55,7.34,7.34,0,0,0,4.036,1.12,7.34,7.34,0,0,0,4.036-1.12,3.135,3.135,0,0,0,1.557-2.566A3.128,3.128,0,0,0,9.629,1.108Z",
    transform: "translate(3.751 10.057)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAdmin);
export default __webpack_public_path__ + "static/media/sidebar-admin.e537d4fa187f99535dd64a93fb72f93e.svg";
export { ForwardRef as ReactComponent };